var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _path8, _polygon3, _polygon4, _path9, _path10, _polygon5, _polygon6, _path11, _path12, _path13, _polygon7, _path14, _path15, _polygon8, _polygon9, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Badges",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "185.5 -25.5 128 128",
    enableBackground: "new 185.5 -25.5 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.5,58.5h-120c-2.2,0-4-1.8-4-4v-32c0-2.2,1.8-4,4-4h120c2.2,0,4,1.8,4,4v32C313.5,56.7,311.7,58.5,309.5,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.7674,
    y1: 25.0736,
    x2: 207.3656,
    y2: 48.0645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006884"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8AD1D0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_1_)",
    d: "M195.3,38.1V27.6c0-0.6,0.5-1.1,1-1.1c0.5,0,0.7,0.1,1,0.3 l19.3,10.6c0.4,0.2,0.6,0.5,0.6,0.8c0,0.3-0.2,0.6-0.6,0.8l-19.3,10.6c-0.2,0.1-0.5,0.3-1,0.3c-0.5,0-1-0.5-1-1.1V38.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.9407,
    y1: 28.3438,
    x2: 210.1967,
    y2: 36.5913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24BBB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBE692"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_2_)",
    d: "M207.8,38.2l-11.7-11.7c0.1,0,0.1,0,0.2,0 c0.5,0,0.7,0.1,1,0.3l14.2,7.8L207.8,38.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.4944,
    y1: 42.1201,
    x2: 212.4944,
    y2: 34.1717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCC072"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F58A5B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_3_)",
    d: "M211.4,41.7l-3.6-3.6l3.7-3.7l5.1,2.8 c0.4,0.2,0.6,0.5,0.6,0.8c0,0.3-0.2,0.6-0.6,0.8L211.4,41.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.8947,
    y1: 51.7691,
    x2: 209.9464,
    y2: 39.5039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712B8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA1D27"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_4_)",
    d: "M196.2,49.7L196.2,49.7l11.6-11.6l3.6,3.6l-14.1,7.7 C197,49.6,196.8,49.7,196.2,49.7C196.3,49.7,196.3,49.7,196.2,49.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M256.6,52.4c-0.5-0.4-0.9-1.1-1.1-1.5l1.6-0.7 c0.1,0.2,0.3,0.5,0.5,0.8c0.4,0.4,1,0.8,1.6,0.8c0.6,0,1.3-0.3,1.7-0.8c0.3-0.5,0.5-1,0.5-1.7v-0.6c-1.2,1.5-3.7,1.3-5.1-0.3 c-1.5-1.6-1.5-4.3,0-5.9c1.5-1.5,3.7-1.7,5-0.3c0,0,0,0,0,0v-0.7h1.7V49c0,1.9-0.7,3-1.6,3.7c-0.6,0.5-1.5,0.7-2.3,0.7 C258.2,53.3,257.3,53,256.6,52.4L256.6,52.4z M298.5,52.8L298.5,52.8l1.7-4l-3-6.9h1.7l2.1,4.9l2.1-4.9h1.7l-4.6,10.9H298.5 L298.5,52.8z M290.4,49L290.4,49c-0.5-0.5-0.7-1.2-0.7-1.9c0-0.6,0.2-1.2,0.6-1.6c0.7-0.7,1.7-1,2.8-1c0.7,0,1.3,0.1,1.8,0.4 c0-1.2-1-1.7-1.8-1.7c-0.7,0-1.4,0.4-1.7,1.1l-1.5-0.6c0.3-0.7,1.1-2,3.1-2c1,0,2,0.3,2.6,1c0.6,0.7,0.8,1.5,0.8,2.6v4.2h-1.7v-0.7 c-0.2,0.3-0.6,0.5-0.9,0.7c-0.4,0.2-0.9,0.3-1.4,0.3C291.8,49.7,290.9,49.5,290.4,49L290.4,49z M237.1,45.4L237.1,45.4 c0-2,1.5-4.2,4.2-4.2c2.6,0,4.2,2.2,4.2,4.2c0,2-1.5,4.2-4.2,4.2C238.6,49.6,237.1,47.4,237.1,45.4L237.1,45.4z M246.1,45.4 L246.1,45.4c0-2,1.5-4.2,4.2-4.2c2.6,0,4.2,2.2,4.2,4.2c0,2-1.5,4.2-4.2,4.2C247.7,49.6,246.1,47.4,246.1,45.4L246.1,45.4z  M225.8,47.6L225.8,47.6c-2.5-2.5-2.4-6.6,0.1-9.2c1.3-1.3,2.9-1.9,4.6-1.9c1.6,0,3.2,0.6,4.4,1.8l-1.2,1.3 c-1.8-1.8-4.7-1.7-6.4,0.1c-1.8,1.9-1.8,4.8,0,6.7c1.8,1.9,4.8,2,6.6,0.1c0.6-0.6,0.8-1.4,0.9-2.2h-4.2v-1.8h5.9 c0.1,0.4,0.1,0.9,0.1,1.4c0,1.5-0.6,3-1.6,4c-1.1,1.1-2.7,1.7-4.3,1.7C228.9,49.5,227.1,48.9,225.8,47.6L225.8,47.6z M268.1,48.3 L268.1,48.3c-1.5-1.6-1.5-4.3,0-6c1.5-1.6,4-1.6,5.4,0c0.5,0.5,0.8,1.2,1.1,1.9l-5.5,2.3c0.3,0.7,1,1.3,2,1.3 c0.9,0,1.5-0.3,2.1-1.2l1.5,1h0c-0.2,0.2-0.4,0.4-0.5,0.6C272.5,49.9,269.6,49.9,268.1,48.3L268.1,48.3z M278.5,49.5L278.5,49.5 V38.4h3.6c2.1,0,3.8,1.5,3.8,3.3c0,1.8-1.5,3.3-3.4,3.3h-2.2v4.4H278.5L278.5,49.5z M286.9,49.5L286.9,49.5V38.4h1.7v11.1H286.9 L286.9,49.5z M264.3,49.3L264.3,49.3V36.9h1.8v12.4H264.3L264.3,49.3z M294.8,46.2L294.8,46.2c-0.4-0.3-1-0.4-1.6-0.4 c-1.2,0-1.9,0.6-1.9,1.3c0,0.7,0.7,1.1,1.4,1.1C293.7,48.2,294.8,47.4,294.8,46.2L294.8,46.2z M243.6,45.4L243.6,45.4 c0-1.2-0.8-2.5-2.3-2.5c-1.5,0-2.3,1.3-2.3,2.5c0,1.2,0.8,2.5,2.3,2.5C242.7,47.9,243.6,46.6,243.6,45.4L243.6,45.4z M252.6,45.4 L252.6,45.4c0-1.2-0.8-2.5-2.3-2.5c-1.5,0-2.3,1.3-2.3,2.5c0,1.2,0.8,2.5,2.3,2.5C251.8,47.9,252.6,46.6,252.6,45.4L252.6,45.4z  M261.5,46.1L261.5,46.1c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1 c0-0.1-0.1-0.3-0.1-0.4c-0.3-1-1.2-1.7-2.1-1.7c-1.2,0-2.2,1.2-2.2,2.5c0,1.4,1,2.5,2.3,2.5C260.3,47.9,261.1,47.2,261.5,46.1 L261.5,46.1z M268.8,45.2L268.8,45.2l3.7-1.6c-0.4-0.7-1-0.9-1.5-0.9C269.5,42.8,268.6,44.4,268.8,45.2L268.8,45.2z M284.1,41.8 L284.1,41.8c0-1-0.8-1.7-1.9-1.7h-2v3.5h2.1C283.3,43.6,284.1,42.8,284.1,41.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "299.8,50.8 299.8,50.8 299.7,50.8 299.7,50.8 299.7,50.7  299.7,50.7 299.8,50.7 299.8,50.7 299.7,50.7 299.7,50.7 299.7,50.8 299.7,50.8  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M299.8,50.8L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8 L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8 L299.8,50.8z M299.8,50.7L299.8,50.7C299.8,50.7,299.8,50.7,299.8,50.7L299.8,50.7L299.8,50.7L299.8,50.7 C299.8,50.7,299.8,50.7,299.8,50.7L299.8,50.7z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "299.8,50.8 299.8,50.8 299.8,50.7 299.8,50.7 299.8,50.7  299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.8 299.8,50.8  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8 L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8z M299.8,50.7L299.8,50.7L299.8,50.7L299.8,50.7 C299.8,50.7,299.8,50.7,299.8,50.7C299.8,50.7,299.8,50.7,299.8,50.7L299.8,50.7z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.8  299.8,50.8 299.8,50.7 299.8,50.7  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "299.8,50.8 299.8,50.8 299.8,50.7 299.8,50.7 299.8,50.7  299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.8 299.8,50.8  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M299.8,50.8L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8 L299.8,50.8L299.8,50.8L299.8,50.8C299.8,50.8,299.8,50.8,299.8,50.8L299.8,50.8z M299.8,50.8L299.8,50.8 C299.8,50.8,299.8,50.8,299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8L299.8,50.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8 C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8L299.9,50.8L299.9,50.8 C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8z M299.9,50.7L299.9,50.7C299.9,50.7,299.9,50.7,299.9,50.7L299.9,50.7L299.9,50.7 L299.9,50.7C299.9,50.7,299.9,50.7,299.9,50.7L299.9,50.7L299.9,50.7z M299.9,50.8L299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8 L299.9,50.8L299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "299.9,50.7 299.9,50.7 299.9,50.7 299.9,50.7 299.9,50.7  299.9,50.7 299.9,50.7 299.9,50.7 299.9,50.8 299.9,50.8 299.9,50.7  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "299.9,50.8 299.9,50.8 299.9,50.7 299.9,50.7 299.9,50.8  299.9,50.8  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8 C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8z  M299.9,50.7L299.9,50.7C299.9,50.8,299.9,50.8,299.9,50.7C299.9,50.8,299.9,50.8,299.9,50.7L299.9,50.7 C299.9,50.7,299.9,50.7,299.9,50.7C299.9,50.7,299.9,50.7,299.9,50.7L299.9,50.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M299.9,50.8L299.9,50.8L299.9,50.8L299.9,50.8L299.9,50.8 L299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8 C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8 C299.9,50.8,299.9,50.8,299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M300,50.8L300,50.8C300,50.7,300,50.7,300,50.8 C299.9,50.7,299.9,50.7,300,50.8L300,50.8C299.9,50.8,299.9,50.8,300,50.8C300,50.8,300,50.8,300,50.8L300,50.8z M300,50.7 L300,50.7C300,50.8,300,50.8,300,50.7C300,50.8,299.9,50.8,300,50.7L300,50.7C299.9,50.7,300,50.7,300,50.7 C300,50.7,300,50.7,300,50.7L300,50.7z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "300,50.8 300,50.7 300,50.7 300,50.7 300,50.7 300,50.7  300,50.8 300,50.8 300,50.7 300,50.7 300,50.8 300,50.8 300,50.7 300,50.7 300,50.8  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M300,50.8L300,50.8L300,50.8L300,50.8L300,50.8L300,50.8L300,50.8 L300,50.8L300,50.8L300,50.8z M300,50.7L300,50.7L300,50.7L300,50.7C300,50.7,300,50.7,300,50.7C300,50.7,300,50.7,300,50.7 L300,50.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M300,50.8C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8 C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8L300,50.8C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8 C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8C300,50.8,300,50.8,300,50.8C300,50.8,300,50.8,300,50.8L300,50.8 C300,50.8,300,50.8,300,50.8C300,50.8,300,50.8,300,50.8z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "300.1,50.7 300,50.7 300,50.7 300.1,50.7 300.1,50.8  300.1,50.8 300.1,50.7 300.1,50.7  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "300.1,50.8 300.1,50.8 300.1,50.7 300.1,50.7 300.1,50.7  300.1,50.7 300.1,50.7 300.1,50.7 300.1,50.7 300.1,50.7 300.1,50.8 300.1,50.8  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M300.1,50.8L300.1,50.8C300.1,50.7,300.1,50.7,300.1,50.8 L300.1,50.8C300.1,50.7,300.1,50.7,300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8 L300.1,50.8z M300.1,50.7L300.1,50.7C300.1,50.7,300.1,50.7,300.1,50.7L300.1,50.7L300.1,50.7L300.1,50.7 C300.1,50.7,300.1,50.7,300.1,50.7L300.1,50.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M224.4,28.6c0-1.8,1.3-2.9,2.9-2.9c1.1,0,1.8,0.5,2.3,1.2l-0.8,0.5c-0.3-0.4-0.8-0.7-1.5-0.7 c-1.1,0-1.9,0.8-1.9,2c0,1.2,0.8,2,1.9,2c0.6,0,1.1-0.3,1.3-0.5v-0.9H227v-0.9h2.7v2.1c-0.5,0.6-1.3,1-2.3,1 C225.7,31.5,224.4,30.3,224.4,28.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M230.9,31.4v-5.6h3.8v0.9h-2.9v1.4h2.8v0.9h-2.8v1.6h2.9v0.9L230.9,31.4L230.9,31.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M237.5,31.4v-4.7h-1.7v-0.9h4.4v0.9h-1.7v4.7H237.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M243.6,31.4v-5.6h1v5.6C244.6,31.4,243.6,31.4,243.6,31.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M247.3,31.4v-4.7h-1.7v-0.9h4.4v0.9h-1.7v4.7H247.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M253.2,28.6c0-1.7,1.2-2.9,2.9-2.9c1.7,0,2.9,1.2,2.9,2.9s-1.2,2.9-2.9,2.9 C254.4,31.5,253.2,30.2,253.2,28.6z M257.9,28.6c0-1.2-0.7-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.7,2,1.9,2 C257.2,30.6,257.9,29.7,257.9,28.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M264,31.4l-2.9-4v4h-1v-5.6h1l2.9,3.9v-3.9h1v5.6H264z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.547ed9516509db9a3d347be73ee4d555.svg";
export { ForwardRef as ReactComponent };